import Layout from 'containers/Layout'
import EmptyState from 'components/EmptyState'

const NotAuthorized = () => (
  <Layout isSidebar mainContent={<EmptyState label="You do not have access to this page" />} />
)

export default NotAuthorized
